import { deepDiveApi } from '../../config/apis/deep-dive-query';
import { ContactSearchRoute } from '../../config/services-route';
import { providesList } from '../../helpers/provides';
import { ContactProps } from '../contact/contact';
import { TagTypes, WithPagination } from '../types';

interface ContactSearchParams {
  CPF: string;
}

const contactSearchApi = deepDiveApi.injectEndpoints({
  endpoints: builder => ({
    searchContactProfile: builder.query<
      WithPagination<ContactProps[]>,
      ContactSearchParams
    >({
      query: params => {
        const authData = JSON.parse(localStorage?.getItem('auth') as string);
        return {
          headers: {
            CustomerId: authData.customer,
            Accept: 'application/json',
          },
          url: `${ContactSearchRoute.contactSearch}?CPF=${encodeURIComponent(
            params.CPF,
          )}`,
        };
      },
      providesTags: response => providesList(response?.data, TagTypes.Contact),
      transformResponse: (response: any): any => {
        // O backend retorna diretamente um array de contatos
        if (Array.isArray(response)) {
          return {
            data: response,
            meta: {
              size: response.length,
            },
          };
        }

        // Caso a resposta seja no formato anterior (com value)
        return {
          data: response.value || [],
          meta: {
            size: response['@odata.count'] || 0,
          },
        };
      },
    }),
  }),
});

export const { useSearchContactProfileQuery } = contactSearchApi;
